/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Nimble_Giraffe_ZoomInputs */

const fr_chunky_nimble_giraffe_zoom = /** @type {(inputs: Chunky_Nimble_Giraffe_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de l'impersonation de l'utilisateur`)
};

/**

* @param {Chunky_Nimble_Giraffe_ZoomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const chunky_nimble_giraffe_zoom = /** @type {((inputs?: Chunky_Nimble_Giraffe_ZoomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Nimble_Giraffe_ZoomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_chunky_nimble_giraffe_zoom(inputs)
});